import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'formatHoursDecimals',
    standalone: false
})
export class FormatHoursDecimalsPipe implements PipeTransform {

  transform(hoursAmt: number): string {
    if (Number.isInteger(hoursAmt)) return hoursAmt.toFixed(1);

    return hoursAmt.toFixed(2);
  }

}
